import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/object';
import React from 'react';
import {ReactQueryDevtools} from 'react-query-devtools';
import ReactDOM from 'react-dom';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import 'assets/fonts/IRANSans/css/fontiran.css';
import 'assets/fonts/IRANSansX/css/fontiran.css';
import 'assets/style.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import {ClearCacheProvider} from 'react-clear-cache';
import * as Sentry from '@sentry/react';
import {BrowserTracing} from '@sentry/tracing';

Sentry.init({
  dsn: 'https://9bad2de0cbd3ca2c07613494df0100d5@tracking.pezeshket.com/8',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});
ReactDOM.render(
  <ClearCacheProvider auto={true} filename="build.json">
    <App />
    {/* <ReactQueryDevtools /> */}
  </ClearCacheProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
